import { render, staticRenderFns } from "./t-input-group.vue?vue&type=template&id=06c8e1d8"
import script from "./t-input-group.vue?vue&type=script&setup=true&lang=ts"
export * from "./t-input-group.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports